export default "__VITE_ASSET__DEc0d6x8__"